(() => {
  'use strict';
  const MOODS = ['warm', 'cafe', 'focus', 'pop'];
  const USES = ['all', 'desk', 'meeting', 'lounge'];
  const PEOPLE = ['all', 'one', 'small', 'team'];
  const KINDS = ["all", "work", "conference", "meeting", "focus", "entrance", "reception", "relax", "storage"];
  const LEGACY_KINDS = {"chair":"work","table":"meeting","soft":"relax","other":"all","desks":"work","chairs":"work","partitions":"focus","whiteboards":"conference","lounge":"reception"};
  const FAMILIES = [
    { test: /^CR-G34/, key: 'ing', groups: ["work", "focus"], kind: 'chair', uses: ['desk'] },
    { test: /^C01-/, key: 'fabre', groups: ["work", "focus"], kind: 'chair', uses: ['desk'] },
    { test: /^C05-/, key: 'inglife', groups: ["work", "meeting", "relax"], kind: 'chair', uses: ['desk', 'lounge'], cafe: true },
    { test: /^K01-/, key: 'any-chair', groups: ["conference", "meeting", "relax"], kind: 'chair', uses: ['meeting', 'lounge'], cafe: true },
    { test: /^TAN-/, key: 'any-table', groups: ["conference", "meeting", "relax"], kind: 'table', uses: ['meeting', 'lounge'], cafe: true },
    { test: /^NAN-/, key: 'any-sofa', groups: ["meeting", "entrance", "reception", "relax"], kind: 'soft', uses: ['lounge'], cafe: true, single: true },
    { test: /^CR-A2835/, key: 'bezel', groups: ["work", "focus"], kind: 'chair', uses: ['desk'], neutral: true },
    { test: /^K11-B34/, key: 'spline', groups: ["conference", "meeting"], kind: 'chair', uses: ['meeting'], neutral: true },
    { test: /^MT-V127/, key: 'viena', groups: ["conference", "meeting"], kind: 'table', uses: ['meeting'], neutral: true },
    { test: /^CN-153/, key: 'lobby', groups: ["entrance"], kind: 'soft', uses: ['lounge'], neutral: true },
    { test: /^MFR-3L/, key: 'ferry', groups: ["entrance", "reception"], kind: 'soft', uses: ['lounge'], neutral: true },
    { test: /^BWU-SD48/, key: 'edia', groups: ["work", "storage"], kind: 'other', uses: ['desk'], neutral: true },
    { test: /^BB-H936/, key: 'board', groups: ["conference", "meeting"], kind: 'other', uses: ['meeting'], neutral: true }
  ];
  const knownWood = new Set(['C05-B11CGL-AJAJ731']);
  const warmColor = /ブラウン|ベージュ|グレージュ|ブリック|テラコッタ/;
  const neutralColor = /ブラック|グレー|ネイビー|ホワイトブラウン/;
  const brightColor = /ピンク|イエロー|ターコイズ|ピーグリーン|パープル|テラコッタ/;

  function normalizeAnswers(input = {}) {
    return {
      mood: MOODS.includes(input.mood) ? input.mood : '',
      use: USES.includes(input.use) ? input.use : 'all',
      people: PEOPLE.includes(input.people) ? input.people : 'all',
      kind: KINDS.includes(input.kind) ? input.kind : (LEGACY_KINDS[input.kind] || 'all')
    };
  }
  function recommend(catalog, input, limit = 6) {
    const a = normalizeAnswers(input);
    if (!a.mood || !Array.isArray(catalog)) return [];
    const ranked = [];
    for (const item of catalog) {
      if (!item || item.status === 'ARCHIVED' || !/^\d+$/.test(String(item.variantId)) || !/^\d+$/.test(String(item.productId))) continue;
      const f = FAMILIES.find(family => family.test.test(String(item.sku || '')));
      if (!f || (a.use !== 'all' && !f.uses.includes(a.use)) || (a.kind !== 'all' && !f.groups.includes(a.kind))) continue;
      const color = String(item.color || '');
      let reason = '', score = 0;
      if (a.mood === 'warm' && knownWood.has(item.sku)) { reason = 'wood'; score = 30; }
      else if (a.mood === 'warm' && warmColor.test(color)) { reason = 'warmColor'; score = 20; }
      else if (a.mood === 'cafe' && f.cafe) { reason = 'casual'; score = 20; }
      else if (a.mood === 'focus' && (f.neutral || neutralColor.test(color))) { reason = color ? 'neutralColor' : 'simple'; score = 20; }
      else if (a.mood === 'pop' && brightColor.test(color)) { reason = 'brightColor'; score = 20; }
      else continue;
      if (a.mood === 'cafe' && /ホワイトブラウン|ブリックレッド|ディープグリーン|ソフトベージュ|アッシュターコイズ/.test(color)) score += 3;
      if (a.mood === 'cafe' && knownWood.has(item.sku)) score += 2;
      if (a.mood === 'pop') {
        const accent = { 'any-chair': 'ピンク', 'any-table': 'イエロー', 'any-sofa': 'ターコイズ', fabre: 'ピーグリーン', ing: 'イエロー' }[f.key];
        if (accent && color.includes(accent)) score += 3;
      }
      let peopleReason = '';
      if (a.people === 'one' && (f.kind === 'chair' || f.single)) { score += 5; peopleReason = 'singleSeat'; }
      if (a.people === 'small' && f.kind === 'table') { score += 5; peopleReason = 'tableMix'; }
      if (a.people === 'team' && f.kind === 'chair') { score += 5; peopleReason = 'seatMix'; }
      if (item.status === 'ACTIVE' && item.canLink === true) score += 1;
      ranked.push({ item, family: f.key, kind: f.kind, reason, peopleReason, score });
    }
    ranked.sort((a, b) => b.score - a.score || String(a.item.sku).localeCompare(String(b.item.sku), 'ja') || String(a.item.variantId).localeCompare(String(b.item.variantId)));
    const seen = new Set();
    return ranked.filter(r => { if (seen.has(r.family)) return false; seen.add(r.family); return true; }).slice(0, limit);
  }
  function readUrl(href) {
    const p = new URL(href, 'https://example.invalid').searchParams;
    return normalizeAnswers({ mood: p.get('ace_mood'), use: p.get('ace_use'), people: p.get('ace_people'), kind: p.get('ace_kind') });
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { recommend, normalizeAnswers, readUrl, MOODS, USES, PEOPLE, FAMILIES, KINDS };
    return;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  class AcePreferenceFinder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.copy = JSON.parse(this.querySelector('[data-pf-copy]').textContent);
      this.answers = readUrl(window.location.href);
      this.catalog = [];
      this.results = [];
      this.step = 0;
      this.loaded = false;
      this.mode = this.answers.mood ? 'results' : 'intro';
      this.form = this.querySelector('[data-pf-form]');
      this.onSubmit = event => { event.preventDefault(); this.next(); };
      this.onClick = event => this.click(event);
      this.onChange = event => this.change(event);
      this.onMoodKey = event => this.moodKeys(event);
      this.form.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.querySelector('[data-pf-moods]').addEventListener('keydown', this.onMoodKey);
      this.onPop = () => { this.answers = readUrl(window.location.href); this.mode = this.answers.mood ? 'results' : 'intro'; this.step = 0; this.sync(); this.render(); };
      this.onBoard = () => this.updateSaved();
      this.onReady = () => this.loadCatalog();
      this.onLinks = () => { if (this.mode === 'results') this.renderResults(); };
      window.addEventListener('popstate', this.onPop);
      document.addEventListener('ace:board-ready', this.onReady);
      document.addEventListener('ace:board-change', this.onBoard);
      document.addEventListener('ace:product-destination-ready', this.onLinks);
      this.sync(); this.render(); this.loadCatalog();
      this.loadTimer = window.setTimeout(() => { if (!this.loaded) { this.querySelector('[data-pf-loading]').textContent = this.copy.loadError; this.querySelector('[data-pf-reload]').hidden = false; } }, 12000);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.querySelector('[data-pf-moods]')?.removeEventListener('keydown', this.onMoodKey);
      window.removeEventListener('popstate', this.onPop);
      document.removeEventListener('ace:board-ready', this.onReady);
      document.removeEventListener('ace:board-change', this.onBoard);
      document.removeEventListener('ace:product-destination-ready', this.onLinks);
      window.clearTimeout(this.loadTimer);
      this.initialized = false;
    }
    async loadCatalog() {
      if (this.loading || !window.AceBoard) return;
      this.loading = true;
      try {
        await window.AceBoard.ready;
        this.catalog = window.AceBoard.catalog();
        this.loaded = Array.isArray(this.catalog) && this.catalog.length > 0;
        if (this.loaded) { window.clearTimeout(this.loadTimer); this.querySelector('[data-pf-reload]').hidden = true; }
        else this.querySelector('[data-pf-loading]').textContent = this.copy.loadError;
        this.render();
        if (window.AceProductDestination?.ready) Promise.resolve(window.AceProductDestination.ready).then(this.onLinks).catch(() => {});
      } catch (_) { this.querySelector('[data-pf-loading]').textContent = this.copy.loadError; this.querySelector('[data-pf-reload]').hidden = false; }
      finally { this.loading = false; }
    }
    click(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-pf-start')) { this.mode = 'quiz'; this.step = 0; this.sync(); this.render(); this.focusStep(); }
      if (button.hasAttribute('data-pf-back')) { this.step = Math.max(0, this.step - 1); this.render(); this.focusStep(); }
      if (button.hasAttribute('data-pf-reset')) { this.answers = normalizeAnswers(); this.mode = 'intro'; this.step = 0; this.sync(); this.updateUrl(); this.render(); this.querySelector('[data-pf-start]').focus(); }
      if (button.dataset.pfMood) { this.answers.mood = button.dataset.pfMood; this.mode = 'results'; this.sync(); this.updateUrl(); this.render(); this.focusResults(); }
      if (button.hasAttribute('data-pf-edit')) { this.mode = 'quiz'; this.step = 0; this.sync(); this.render(); this.focusStep(); }
      if (button.hasAttribute('data-pf-open')) window.AceBoard?.open();
      if (button.hasAttribute('data-pf-inquire')) this.bulkInquiry(button);
      if (button.dataset.pfSave) this.save(button.dataset.pfSave, button);
      if (button.hasAttribute('data-pf-reload')) window.location.reload();
    }
    change(event) {
      const input = event.target;
      if (input.matches('[data-pf-answer]')) { this.answers[input.dataset.pfAnswer] = input.value; this.renderStep(); }
      if (input.matches('[data-pf-kind]')) { this.answers.kind = input.value; this.updateUrl(); this.renderResults(); }
    }
    next() {
      const key = ['use', 'people', 'mood'][this.step];
      if (!this.form.querySelector(`[data-pf-answer="${key}"]:checked`)) return;
      if (this.step < 2) { this.step += 1; this.renderStep(); this.focusStep(); }
      else { this.mode = 'results'; this.updateUrl(); this.sync(); this.render(); this.focusResults(); }
    }
    sync() {
      this.querySelectorAll('[data-pf-answer]').forEach(input => { input.checked = this.answers[input.dataset.pfAnswer] === input.value; });
      this.querySelector('[data-pf-kind]').value = this.answers.kind;
      this.querySelectorAll('[data-pf-mood]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.pfMood === this.answers.mood)); });
    }
    render() {
      this.form.hidden = this.mode !== 'quiz';
      this.querySelector('[data-pf-results]').hidden = this.mode !== 'results';
      this.querySelector('[data-pf-start]').hidden = this.mode !== 'intro';
      this.querySelector('[data-pf-reset]').hidden = this.mode === 'intro';
      this.renderStep();
      if (this.mode === 'results') this.renderResults();
    }
    renderStep() {
      this.querySelectorAll('[data-pf-step]').forEach((field, index) => { field.hidden = index !== this.step; field.disabled = index !== this.step; });
      const key = ['use', 'people', 'mood'][this.step];
      this.querySelector('[data-pf-next]').disabled = !this.form.querySelector(`[data-pf-answer="${key}"]:checked`);
      this.querySelector('[data-pf-next]').textContent = this.step === 2 ? this.copy.showResults : this.copy.next;
      this.querySelector('[data-pf-back]').hidden = this.step === 0;
      this.querySelector('[data-pf-progress]').textContent = this.format(this.copy.progress, { step: this.step + 1 });
    }
    renderResults() {
      this.results = this.loaded ? recommend(this.catalog, this.answers, Number(this.dataset.limit) || 6) : [];
      const loading = this.querySelector('[data-pf-loading]'); loading.hidden = this.loaded;
      this.querySelector('[data-pf-summary]').textContent = [this.label('mood', this.answers.mood), this.label('use', this.answers.use), this.label('people', this.answers.people)].filter(Boolean).join(' / ');
      this.querySelector('[data-pf-count]').textContent = this.loaded ? this.format(this.copy.resultCount, { count: this.results.length }) : '';
      this.querySelector('[data-pf-empty]').hidden = !this.loaded || this.results.length > 0;
      this.querySelector('[data-pf-draft]').hidden = !this.results.some(r => r.item.canLink !== true || r.item.status !== 'ACTIVE');
      this.querySelector('[data-pf-people-note]').hidden = this.answers.people === 'all';
      const list = this.querySelector('[data-pf-list]'); list.replaceChildren();
      for (const result of this.results) list.append(this.card(result));
      this.querySelector('[data-pf-actions]').hidden = !this.loaded;
      this.querySelector('[data-pf-inquire]').disabled = this.results.length === 0;
      this.updateSaved();
    }
    card(result) {
      const item = result.item, li = document.createElement('li'); li.className = 'ace-preferences__card';
      const destination = window.AceProductDestination?.resolve(item);
      const href = destination && /^\/(products|collections)\//.test(destination.href || '') ? destination.href : '';
      const media = document.createElement(href ? 'a' : 'div'); media.className = 'ace-preferences__media';
      if (href) { media.href = href; media.setAttribute('aria-label', item.title); }
      if (/^https:\/\/cdn\.shopify\.com\//.test(item.image || '')) { const img = document.createElement('img'); img.src = item.image; img.alt = [item.title, item.color].filter(Boolean).join(' / '); img.loading = 'lazy'; img.width = 480; img.height = 360; media.append(img); }
      li.append(media);
      const content = document.createElement('div'); content.className = 'ace-preferences__card-copy';
      const heading = document.createElement('h4'); heading.textContent = item.title; content.append(heading);
      const variant = document.createElement('p'); variant.className = 'ace-preferences__variant'; variant.textContent = [item.color, item.sku].filter(Boolean).join(' / '); content.append(variant);
      const reasons = document.createElement('ul'); reasons.className = 'ace-preferences__reasons';
      const reason = document.createElement('li'); reason.textContent = this.format(this.copy['reason_' + result.reason], { color: item.color }); reasons.append(reason);
      const category = document.createElement('li'); category.textContent = String(item.category || '').split(' / ').slice(-1)[0]; reasons.append(category);
      if (result.peopleReason) { const people = document.createElement('li'); people.textContent = this.copy['reason_' + result.peopleReason]; reasons.append(people); }
      content.append(reasons);
      if (href) { const link = document.createElement('a'); link.href = href; link.className = 'ace-preferences__destination'; link.textContent = destination.kind === 'product' ? this.copy.productLink : this.copy.categoryLink; content.append(link); }
      else { const pending = document.createElement('p'); pending.className = 'ace-preferences__pending'; pending.textContent = this.copy.categoryPending; content.append(pending); }
      const save = document.createElement('button'); save.type = 'button'; save.dataset.pfSave = String(item.variantId); save.className = 'ace-preferences__save'; save.textContent = this.copy.save; content.append(save);
      li.append(content); return li;
    }
    updateSaved() {
      if (!window.AceBoard || !this.loaded) return;
      const ids = new Set(window.AceBoard.list().map(item => String(item.variantId)));
      this.querySelectorAll('[data-pf-save]').forEach(button => { const saved = ids.has(button.dataset.pfSave); button.disabled = saved; button.textContent = saved ? this.copy.saved : this.copy.save; });
    }
    async save(id, button) {
      const row = this.results.find(r => String(r.item.variantId) === id); if (!row || !window.AceBoard) return;
      button.disabled = true;
      try { const result = await window.AceBoard.add(row.item); this.status(result.ok ? this.copy.savedMessage : this.copy.saveError); }
      catch (_) { this.status(this.copy.saveError); }
      this.updateSaved();
    }
    async bulkInquiry(button) {
      if (!this.results.length || !window.AceBoard) return;
      button.disabled = true;
      try { const result = await window.AceBoard.addMany(this.results.map(r => r.item)); if (result.ok) window.AceBoard.open(); else this.status(this.copy.partialError); }
      catch (_) { this.status(this.copy.saveError); }
      button.disabled = false; this.updateSaved();
    }
    updateUrl() {
      const url = new URL(window.location.href);
      for (const key of ['mood', 'use', 'people', 'kind']) { const value = this.answers[key]; if (value && value !== 'all') url.searchParams.set('ace_' + key, value); else url.searchParams.delete('ace_' + key); }
      url.hash = 'AcePreferenceFinder';
      window.history.pushState({ acePreference: true }, '', url.pathname + url.search + url.hash);
    }
    moodKeys(event) {
      const buttons = [...this.querySelectorAll('[data-pf-mood]')], index = buttons.indexOf(event.target);
      if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault(); const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next].focus();
    }
    focusStep() { this.querySelector(`[data-pf-step="${this.step}"] legend`).focus(); }
    focusResults() { this.querySelector('[data-pf-results-title]').focus(); }
    status(message) { this.querySelector('[data-pf-status]').textContent = message; }
    format(value, data) { return String(value || '').replace(/\{(\w+)\}/g, (_, key) => data[key] ?? ''); }
    label(group, value) { return value && value !== 'all' ? this.copy[group + '_' + value] || '' : ''; }
  }
  if (!customElements.get('ace-preference-finder')) customElements.define('ace-preference-finder', AcePreferenceFinder);
})();


